import { viewport } from '../../../utils/viewport';
import { loadChartScript } from '../../../utils/scripts';

class ChartDoughnut {
  constructor(el) {
    this.el = el;
    this.canvas = el.querySelector('.chart-doughnut__canvas');
    this.ctx = this.canvas.getContext('2d');
    this.data = JSON.parse(el.querySelector('.chart-doughnut__data').innerHTML);
    this.palette = [
      'rgb(38, 116, 224)',
      'rgb(255, 205, 50)',
      'rgb(135, 205, 220)',
      'rgb(245, 75, 25)',
      'rgb(245, 200, 200)',
    ];

    loadChartScript().then(() => {
      viewport.observe(this.el, () => {
        if (!this.chart) {
          this.chart = new Chart(this.ctx, this.getOptions());
        }
      });
    });
  }

  getOptions() {
    return {
      type: 'doughnut',
      data: {
        labels: this.data.map((item) => item.label),
        datasets: [
          {
            data: this.data.map((item) => item.value),
            backgroundColor: this.palette,
            hoverBackgroundColor: this.palette,
          },
        ],
      },
      options: {
        datasets: {
          doughnut: {
            cutout: '60%',
            hoverBorderWidth: 0,
            hoverOffset: 0,
            offset: 0,
            borderRadius: 4,
          },
        },
        animation: {
          animateScale: true,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            backgroundColor: 'rgb(255, 255, 255)',
            bodyColor: 'rgb(40, 25, 50)',
            titleColor: 'rgb(40, 25, 50)',
            padding: 16,
            callbacks: {
              label: (item) => {
                return this.el.dataset.prefix + item.parsed + this.el.dataset.suffix;
              },
              title: (item) => {
                return item[0].label;
              },
            },
          },
        },
      },
    };
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.chart-doughnut').forEach((el) => new ChartDoughnut(el));

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview', ($block, attributes) => {
    $block.find('.chart-doughnut').each((i, el) => new ChartDoughnut(el, attributes));
  });
}